export default function getDiffInMinutes(lastItemUpdateTime: number) {
  const currentTime = Date.now();
  const differenceInMilliseconds = currentTime - lastItemUpdateTime;
  return Math.floor(differenceInMilliseconds / 1000 / 60);
}
